"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackPLPViewChange = void 0;
const enums_1 = require("../enums");
const trackGA4EventWithCleanUp_1 = require("./trackGA4EventWithCleanUp");
function trackPLPViewChange(click_value, event_label) {
    const eventData = {
        eventName: enums_1.GA4EventName.ClickButton,
        feature_category: enums_1.GA4FeatureCategory.ProductList,
        click_element: event_label,
        click_value,
    };
    (0, trackGA4EventWithCleanUp_1.trackGA4EventWithCleanUp)({
        eventCategory: enums_1.EventCategory.ProductList,
        eventAction: enums_1.ClickEventType.BUTTON_CLICK,
        eventLabel: event_label,
        eventData,
    });
}
exports.trackPLPViewChange = trackPLPViewChange;
//# sourceMappingURL=trackPLPViewChange.js.map